import { useState } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { ChatWidget } from './ChatWidget';
import { CartDrawer } from './CartDrawer';
import { useCart } from '../lib/cart';

const logoSrc = '/assets/BO Hummingbird Logo Light crop_1759682568667.png';

function navClassName({ isActive }: { isActive: boolean }) {
  return isActive ? 'active' : undefined;
}

export function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { count, toggleCart } = useCart();
  const close = () => setMenuOpen(false);

  return (
    <>
      <header className="site-header">
        <div className="container nav-inner">
          <Link to="/" className="brand" onClick={close}>
            <img src={logoSrc} alt="Bizi Office" />
          </Link>

          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li>
              <NavLink to="/" end className={navClassName} onClick={close}>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to="/services" className={navClassName} onClick={close}>
                Services
              </NavLink>
            </li>
            <li>
              <NavLink to="/marketplace" className={navClassName} onClick={close}>
                Bizi Marketplace
              </NavLink>
            </li>
            <li>
              <NavLink to="/how-it-works" className={navClassName} onClick={close}>
                How It Works
              </NavLink>
            </li>
          </ul>

          <div className="nav-cta">
            <Link to="/marketplace" className="btn btn-ghost desktop-only">
              Shop Extensions
            </Link>
            <a
              href="/#contact"
              className="btn btn-primary desktop-only"
              onClick={(e) => {
                e.preventDefault();
                const el = document.getElementById('contact');
                if (el) {
                  el.scrollIntoView({ behavior: 'smooth', block: 'end' });
                  close();
                } else {
                  window.location.href = '/#contact';
                }
              }}
            >
              Talk to Us
            </a>
            <button
              type="button"
              className="nav-cart"
              onClick={toggleCart}
              aria-label={count ? `Open cart, ${count} items` : 'Open cart'}
            >
              <span className="material-symbols-outlined">shopping_cart</span>
              {count > 0 && <span className="nav-cart-badge">{count > 99 ? '99+' : count}</span>}
            </button>
            <button
              className={`hamburger ${menuOpen ? 'open' : ''}`}
              aria-label="Toggle menu"
              onClick={() => setMenuOpen((v) => !v)}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </header>

      <main className="site-main">
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <img src={logoSrc} alt="Bizi Office" />
              <p>Eliminating busy work — and shipping EspoCRM extensions that feel like home field advantage.</p>
            </div>
            <div className="footer-col">
              <h4>Services</h4>
              <Link to="/services">All Services</Link>
              <Link to="/services#email-communication">Email Automation</Link>
              <Link to="/services#customer-support">Customer Support AI</Link>
              <Link to="/services#sales-leads">Sales Automation</Link>
              <Link to="/services#workflow-integration">Workflow Automation</Link>
            </div>
            <div className="footer-col">
              <h4>Marketplace</h4>
              <Link to="/marketplace">All Extensions</Link>
              <Link to="/marketplace/bizi-list-view-pro">List View Pro</Link>
              <Link to="/marketplace/bizi-enum-plus">Enum Plus</Link>
              <Link to="/marketplace/bizi-dark-glass">Dark Glass Theme</Link>
            </div>
            <div className="footer-col">
              <h4>Company</h4>
              <Link to="/">Home</Link>
              <Link to="/how-it-works">How It Works</Link>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© {new Date().getFullYear()} Bizi Office / Prog AI, LLC. All rights reserved.</p>
          </div>
        </div>
      </footer>

      <CartDrawer />
      <ChatWidget />
    </>
  );
}
